import { Box, Typography } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";

const CaptchaField = ({
  value,
  onChange,
  error,
  siteKey = process.env.REACT_APP_SITE_KEY,
}) => (
  <Box sx={{ my: 2 }}>
    <ReCAPTCHA sitekey={siteKey} onChange={onChange} />
    {error && (
      <Typography color="error" variant="caption">
        {error}
      </Typography>
    )}
  </Box>
);

export default CaptchaField;
